/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  getUnreadCounts() {
    return axios.get(`${this.url}/unread_counts`);
  }

  updateConfidentialMode(conversationID, enabled) {
    return this.update(conversationID, { confidential_mode: enabled });
  }

  startWhatsappConversation(conversationID, phoneNumber) {
    return axios.post(
      `${this.url}/${conversationID}/start_whatsapp_conversation`,
      { phone_number: phoneNumber }
    );
  }

  getWhatsappGroupParticipants(conversationID) {
    return axios.get(
      `${this.url}/${conversationID}/whatsapp_group_participants`
    );
  }

  updateOperationalStatus(conversationID, conversationStatusId) {
    return axios.patch(`${this.url}/${conversationID}/operational_status`, {
      conversation_status_id: conversationStatusId,
    });
  }

  getServiceTemplates(conversationID) {
    return axios.get(`${this.url}/${conversationID}/service_templates`);
  }

  attachServiceTemplate(conversationID, serviceTemplateId) {
    return axios.post(`${this.url}/${conversationID}/service_templates`, {
      service_template_id: serviceTemplateId,
    });
  }

  updateServiceTemplate(conversationID, assignmentId, checklist) {
    return axios.patch(
      `${this.url}/${conversationID}/service_templates/${assignmentId}`,
      { checklist }
    );
  }

  removeServiceTemplate(conversationID, assignmentId) {
    return axios.delete(
      `${this.url}/${conversationID}/service_templates/${assignmentId}`
    );
  }
}

export default new ConversationApi();
